import { useTradingStore } from '../hooks/useTradingStore'
import { ArrowUpRight, ArrowDownRight } from 'lucide-react'
import clsx from 'clsx'

export default function RecentTrades() {
  const { trades } = useTradingStore()

  // Get last 5 trades
  const recentTrades = trades.slice(-5).reverse()

  const formatTime = (timestamp: number) => {
    const date = new Date(timestamp / 1_000_000) // Convert from nanoseconds
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    })
  }

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Recent Trades</h3>
        <span className="text-xs text-[#666]">{trades.length} total</span>
      </div>

      {recentTrades.length === 0 ? (
        <div className="text-center py-6 text-[#666] text-sm">
          No trades yet
        </div>
      ) : (
        <div className="space-y-2">
          {recentTrades.map((trade, index) => {
            const isLong = trade.side === 'LONG' || trade.side === 'BUY'
            return (
              <div
                key={`${trade.order_id || index}-${trade.timestamp}`}
                className="flex items-center justify-between py-2 px-2 rounded bg-[#1a1a1a]"
              >
                <div className="flex items-center gap-2">
                  <div className={clsx(
                    'w-6 h-6 rounded flex items-center justify-center',
                    isLong ? 'bg-green-500/10' : 'bg-red-500/10'
                  )}>
                    {isLong ? (
                      <ArrowUpRight size={14} className="text-green-400" />
                    ) : (
                      <ArrowDownRight size={14} className="text-red-400" />
                    )}
                  </div>
                  <div>
                    <div className={clsx(
                      'text-sm font-medium',
                      isLong ? 'text-green-400' : 'text-red-400'
                    )}>
                      {trade.side}
                    </div>
                    <div className="text-xs text-[#666]">
                      {trade.type || 'Entry'}
                    </div>
                  </div>
                </div>

                <div className="text-right">
                  <div className="text-sm font-mono font-medium text-white">
                    ${trade.price.toFixed(2)}
                  </div>
                  <div className="text-xs text-[#666]">
                    {formatTime(trade.timestamp)}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
